/**
 * Resolves some cases with special Id when using import-map entries
 * Id containing version number e.g. vue@3.2.45 should match imports which is vue@3
 * If it does not find vue@3 then look for vue
 * @param {string} id - import map entry
 * @param {Object} imports - import map values
 * @returns - resolved string or undefined
 */
export function resolveVersion(id, imports) {
  if (!id) return;
  if (id.indexOf("@") !== -1) {
    var segment = id.slice(0, id.indexOf("@"));
    var majorVersion = id
      .slice(id.indexOf("@") + 1, id.length)
      .split(".")
      .map(Number)[0];
    if (!majorVersion) return;
    var match = `${segment}@${majorVersion}`;
    var mapped =
      imports[match] !== null && imports[match] !== undefined
        ? imports[match]
        : imports[segment];
    if (mapped) return mapped;
    return;
  }
  return;
}
